export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-vegas.vue?vue&type=template&id=3a7f294c"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-vegas.vue?vue&type=template&id=3a7f294c
// module id = HbDi
// module chunks = 0